import { BlobServiceClient } from '@azure/storage-blob';
import { getSasTokenAsync } from 'data/storage';

export const uploadImageAndGetUrl = async (file: File) => {
  const sasToken = await getSasTokenAsync();
  const storageAccountName = 'nupitchstorage';
  const containerName = 'nupitch-test-blob-container';
  const blobServiceClient = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net${sasToken}`
  );
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const blobClient = containerClient.getBlockBlobClient(file.name);

  await blobClient.uploadBrowserData(file, {
    blobHTTPHeaders: { blobContentType: file.type }
  });
  const url = blobClient.url.split('?')[0];

  return url;
};
